import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormik, validateYupSchema } from "formik";
import { ReactComponent as CloseBtn } from "../../../assets/icons/Icon.svg";
import { Box } from "@mui/material";
import { CONSULTATION_MODAL_ACTION_TYPE } from "../../../redux/actions-type";
import SubmitBtn from "./components/Buttons/SubmitBtn";
import InputField from "./components/Inputs/InputField";
import Course from "./components/SelectCollection/Course";
import Teacher from "./components/SelectCollection/Teacher";
import WhereComing from "./components/SelectCollection/WhereComing";
import Persona from "./components/SelectCollection/Persona";
import Knowledge from "./components/SelectCollection/Knowledge";
import CancelReason from "./components/SelectCollection/CancelReason";
import Status from "./components/SelectCollection/Status";
import Group from "./components/SelectCollection/Group";
import { validationSchema } from "./components/ValidationSchema/ValidationSchema";
import Worker from "./components/SelectCollection/Worker";
import PaymentData from "./paymentData/PaymentData";
import Contract from "./components/SelectCollection/Contract";
import Company from "./components/SelectCollection/Company";
import StatusInputField from "./components/Inputs/StatusInputField";

const ConsultationModal = () => {
  const dispatch = useDispatch();
  const { consultationModalData: modalData } = useSelector(
    (state) => state.consultationModal,
  );


  // console.log(modalData, "modal data");
  const ValidationSchema = validationSchema(modalData);

  // formik
  const formik = useFormik({
    initialValues: {
      studentName: modalData?.studentName || "",
      fin: modalData?.fin || "",
      seria: modalData?.seria || "",
      contactDate: modalData?.contactDate || "",
      constDate: modalData?.constDate || "",
      constTime: modalData?.constTime || "",
      course: modalData?.course || "",
      group: modalData?.group || "",
      salesDate: modalData?.salesDate || "",
      whereComing: modalData?.whereComing || "",
      worker: modalData?.worker || "",
      course: modalData?.course || "",
      paymentData: modalData?.paymentData || {},
    },
    validationSchema: ValidationSchema,
    validateOnMount: true,
  });
  
  const setInputValue = useCallback(
    (key, value) =>
      formik.setValues({
        ...formik.values,
        [key]: value,
        ...(key === "course" ? { group: "" } : {}),
      }),
    [formik],
  );

  const updateModalState = (keyName, value) => {
    setInputValue(keyName, value);
    dispatch({
      type: CONSULTATION_MODAL_ACTION_TYPE.GET_CONSULTATION_MODAL,
      payload: {
        data: {
          ...modalData,
          [keyName]: value,
          ...(keyName === "course" ? { group: "" } : {}),
        },
        openModal: true,
      },
    });
  };
  const closeModal = () => {
    dispatch({
      type: CONSULTATION_MODAL_ACTION_TYPE.GET_CONSULTATION_MODAL,
      payload: { data: {}, openModal: false },
    });
  };

  useEffect(() => {
    setInputValue("studentPhone", modalData?.studentPhone || "");
  }, [modalData.status, modalData?.group]);

  return (
    <div className="create-update-modal-con teacher-modal">
      <div className="create-update-modal">
        <div className="create-update-modal-head">
          <h2>{modalData?._id ? "Lead yenilə" : "Lead əlavə et"}</h2>
          <CloseBtn onClick={closeModal} />
        </div>

        <Box
          onSubmit={(e) => e.preventDefault()}
          component="form"
          sx={{
            width: 500,
            maxWidth: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div className="create-update-modal-form">
            <InputField
              inputName="studentName"
              formik={formik}
              setInputValue={setInputValue}
              modalData={modalData}
              updateModalState={updateModalState}
            />

            {modalData?._id && (
              <>
                <div className="input-couples">
                  <InputField
                    inputName="fin"
                    formik={formik}
                    modalData={modalData}
                    updateModalState={updateModalState}
                  />{" "}
                  <InputField
                    inputName="seria"
                    formik={formik}
                    modalData={modalData}
                    updateModalState={updateModalState}
                  />{" "}
                </div>
                <div className="input-couples birthday">
                  <InputField
                    inputName="birthday"
                    formik={formik}
                    modalData={modalData}
                    updateModalState={updateModalState}
                  />
                  <InputField
                    inputName="studentPhone"
                    formik={formik}
                    modalData={modalData}
                    updateModalState={updateModalState}
                  />
                </div>
              </>
            )}
            {modalData?._id && (
              <>
                <div className="input-couples-full birthday">
                  <InputField
                    inputName={"createdAt"}
                    formik={formik}
                    modalData={modalData}
                    updateModalState={updateModalState}
                  />
                </div>
                <Worker
                  modalData={modalData}
                  updateModalState={updateModalState}
                  formik={formik}
                />
                <Status
                  modalData={modalData}
                  updateModalState={updateModalState}
                  formik={formik}
                />

                {/* {modalData.status === "new-lead" && (
                  <InputField
                    inputName="firstCallAddInfo"
                    formik={formik}
                    modalData={modalData}
                    updateModalState={updateModalState}
                  />
                )}{" "}
                {modalData.status === "ws-message" && (
                  <InputField
                    inputName="wsMessageAddInfo"
                    formik={formik}
                    modalData={modalData}
                    updateModalState={updateModalState}
                  />
                )}{" "} */}
                {/* {modalData.status === "warm-call" && (
                  <InputField
                    inputName="warmCallAddInfo"
                    formik={formik}
                    modalData={modalData}
                    updateModalState={updateModalState}
                  />
                )}{" "}
                {modalData.status === "cold-call" && (
                  <InputField
                    inputName="coldCallAddInfo"
                    formik={formik}
                    modalData={modalData}
                    updateModalState={updateModalState}
                  />
                )}{" "} */}
                {/* {modalData.status === "ice-call" && (
                  <InputField
                    inputName="iceCallAddInfo"
                    formik={formik}
                    modalData={modalData}
                    updateModalState={updateModalState}
                  />
                )}{" "}
                {modalData.status === "appointed" && (
                  <InputField
                    inputName="appointedConsultationAddInfo"
                    formik={formik}
                    modalData={modalData}
                    updateModalState={updateModalState}
                  />
                )}{" "} */}
                {/* {modalData.status === "sold" && (
                  <InputField
                    inputName="salesAddInfo"
                    formik={formik}
                    modalData={modalData}
                    updateModalState={updateModalState}
                  />
                )}{" "}
                {modalData.status === "cancelled" && (
                  <InputField
                    inputName="cancelledAddInfo"
                    formik={formik}
                    modalData={modalData}
                    updateModalState={updateModalState}
                  />
                )}{" "} */}
                {modalData.status === "cancelled" && (
                  <CancelReason
                    modalData={modalData}
                    updateModalState={updateModalState}
                    formik={formik}
                  />
                )}
                {modalData?.status && (
                  <InputField
                    inputName="addInfo"
                    formik={formik}
                    modalData={modalData}
                    updateModalState={updateModalState}
                  />
                )}
              </>
            )}
            {!modalData?._id && (
              <div className="input-couples birthday">
                {" "}
                <InputField
                  inputName="studentPhone"
                  formik={formik}
                  modalData={modalData}
                  updateModalState={updateModalState}
                />
                <InputField
                  inputName={"contactDate"}
                  formik={formik}
                  modalData={modalData}
                  updateModalState={updateModalState}
                />
              </div>
            )}

            <WhereComing
              modalData={modalData}
              updateModalState={updateModalState}
              formik={formik}
            />
            <Course
              modalData={modalData}
              updateModalState={updateModalState}
              formik={formik}
            />

            {!modalData?._id && (
              <Worker
                modalData={modalData}
                updateModalState={updateModalState}
                formik={formik}
              />
            )}

            {modalData?._id && (
              <>
                <Contract
                  modalData={modalData}
                  updateModalState={updateModalState}
                  formik={formik}
                />
                {["B2C"].includes(modalData?.contract?.contractType) && (
                  <PaymentData
                    modalData={modalData}
                    updateModalState={updateModalState}
                    formik={formik}
                    setInputValue={setInputValue}
                  />
                )}
                {["B2B", "B2G", "B2C-Corporate"].includes(
                  modalData?.contract?.contractType,
                ) && (
                  <Company
                    modalData={modalData}
                    updateModalState={updateModalState}
                    formik={formik}
                    setInputValue={setInputValue}
                  />
                )}
                {["barter"].includes(modalData?.contract?.contractType) && (
                  <InputField
                    inputName="barterService"
                    formik={formik}
                    setInputValue={setInputValue}
                    modalData={modalData}
                    updateModalState={updateModalState}
                  />
                )}
                <Group
                  modalData={modalData}
                  updateModalState={updateModalState}
                  formik={formik}
                />
              </>
            )}
            <div className="utm-data-container">
            
                <div className="utm-data">
                  <span>utmSource: {modalData?.utmSource}</span>
                </div>
              
                <div className="utm-data">
                  <span>utmMedium: {modalData?.utmMedium}</span>
                </div>
                <div className="utm-data">
                  <span>utmCampaign: {modalData?.utmCampaign}</span>
                </div>
                <div className="utm-data">
                  <span>utmContent: {modalData?.utmContent}</span>
                </div>
                <div className="utm-data">
                  <span>utmTerm: {modalData?.utmTerm}</span>
                </div>
                <div className="utm-data">
                  <span>request_id: {modalData?.externalRequestId}</span>
                </div>
              
            </div>
          </div>
        </Box>

        {modalData?._id ? (
          // <div className="create-update-modal-btn-con">
          <SubmitBtn formik={formik} modalData={modalData} funcType="update" />
        ) : (
          // </div>
          <SubmitBtn formik={formik} modalData={modalData} funcType="create" />
        )}
      </div>
    </div>
  );
};

export default ConsultationModal;
